import { render, staticRenderFns } from "./MaterialEditModal.vue?vue&type=template&id=6324e5b0"
import script from "./MaterialEditModal.vue?vue&type=script&lang=js"
export * from "./MaterialEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports